export default "__VITE_ASSET__40a05407__"